<!-- eslint-disable vue/require-v-for-key -->
<template>
  <div class="container customplaceholder pt-5">
    <div class="d-flex justify-content-between align-items-center mb-4">
      <div>
        <router-link
          :to="
            $route.params.type === 'create'
              ? '/request-shipment-type'
              : '/warehouse-list/draft'
          "
          class="d-flex justify-content-center align-items-center"
          style="text-decoration: none;color: #1D3354;"
        >
          <img class="mr-2" src="@/assets/image/icon/cheveron-left.svg" />
          Back
        </router-link>
      </div>
      <div class="d-flex">
        <button
          class="button__bluecorporite mr-2"
          style="min-width: 118px;
            min-height: 29px;
            padding: 4px 6px;
            display: flex;
            align-items: center;
            justify-content: center;
            border-radius: 4px !important;
            font-size: 12px !important;"
          :disabled="listData && listData.length === 0"
          @click="confirm('draft')"
        >
          Save as Draft
        </button>
        <button
          class="button__bluecorporite"
          style="min-width: 118px;
            min-height: 29px;
            padding: 4px 6px;
            display: flex;
            align-items: center;
            justify-content: center;
            border-radius: 4px !important;
            font-size: 12px !important;"
          :disabled="listData && listData.length === 0"
          @click="confirm('create')"
        >
          Submit Inbound
        </button>
      </div>
    </div>
    <div class="pdetail__border p-4 mb-5">
      <p class="pdetail__header mb-3 mt-2">Inbound Info</p>
      <div class="d-flex mb-3">
        <div class="col-6">
          <p class="fontstyle__default mb-1">Warehouse</p>
          <div class="options__multipleselect">
            <multiselect
              v-model="form.warehouse"
              :options="warehouseList || []"
              placeholder="Select warehouse"
              label="name"
              :select-label="''"
              :deselect-label="''"
              v-validate="'required'"
              name="Warehouse"
            >
              <span slot="noResult">Oops! No elements found.</span>
            </multiselect>
            <img
              class="options__multipleselect--imgabsolute"
              src="@/assets/image/icon/arrow-down-full-blue.svg"
            />
          </div>
          <p
            v-if="errors.has('Warehouse')"
            class="global__texterror text-left py-1"
          >
            {{ errors.first('Warehouse') }}
          </p>
        </div>
        <div class="col-6">
          <p class="fontstyle__default mb-1">Inbound Date</p>
          <div class="input__model1group">
            <b-input-group>
              <b-form-input
                v-model="form.dateInbound"
                type="date"
                name="Inbound Date"
                v-validate="'required'"
              />
            </b-input-group>
            <p v-if="errors.has('Inbound Date')" class="fontstyle__errormsg">
              {{ errors.first('Inbound Date') }}
            </p>
          </div>
        </div>
      </div>
      <div class="d-flex mb-5">
        <div class="input__model1group col-6">
          <p class="fontstyle__default">Nomor Pengajuan (Optional)</p>
          <b-form-input
            type="text"
            placeholder="Type your reference number"
            v-model="form.nomorPengajuan"
            name="Pengajuan Number"
          ></b-form-input>
        </div>
        <div class="input__model1group col-6">
          <p class="fontstyle__default">Reference Number (Optional)</p>
          <b-form-input
            type="text"
            placeholder="Type your reference number"
            v-model="form.referenceNumber"
            name="Reference Number"
          ></b-form-input>
        </div>
      </div>
      <div class="d-flex justify-content-between align-items-center mb-3">
        <p class="pdetail__header m-0">SKU Information</p>
        <div class="d-flex items-center">
          <button
            class="button__bluecorporite mr-2"
            :disabled="listData.length == 0"
            style="min-width: 124px;
            min-height: 29px;
            padding: 4px 6px;
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 12px !important;
            border-radius: 4px !important;"
            @click="supportingDocumentModal = true"
          >
            Add Supporting Document
          </button>
          <button
            class="button__whiteblueborder mr-2"
            :disabled="
              listData.length != 0 && form.multipleSkuStatus == 1 ? true : false
            "
            style="min-width: 118px;
            min-height: 29px;
            padding: 4px 6px;
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 12px !important;
            border-radius: 4px !important;
            box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0.16);"
            @click="
              listData.length != 0 && form.multipleSkuStatus == 1
                ? null
                : openMultipleSKUModal()
            "
          >
            Add Multiple SKU
          </button>
          <button
            class="button__bluecorporite"
            style="min-width: 118px;
            min-height: 29px;
            padding: 4px 6px;
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 12px !important;"
            @click="addModalSKU"
          >
            Add SKU
          </button>
        </div>
      </div>
      <div
        v-if="listData && listData.length === 0"
        class="pdetail__border d-flex justify-content-center align-items-center p-4 mb-5"
        style="height: 130px;"
      >
        <div class="pdetail__paragraph1 text-center">
          <img src="@/assets/image/icon/sku-notfound.svg" alt="" />
          <p>There is no SKU data available</p>
        </div>
      </div>
      <div v-else>
        <!-- supporting document -->
        <p class="text-6e6e6e text-sm mb-2">Supporting Document :</p>
        <div class="d-flex align-items-center" style="flex-wrap: wrap">
          <p
            v-for="(item, index) in form.fileSupportingDocument"
            :key="index"
            class="text-blue text-sm font-semibold pr-1 mb-3"
          >
            {{ item.name || item.original_name || '-' }}
            <template v-if="index < form.fileSupportingDocument.length - 1">
              ,
            </template>
          </p>
        </div>

        <!-- total list sku dan search input -->
        <div class="d-flex align-items-center justify-content-between mb-3">
          <p class="text-sm" style="color: #7E7E7E;">
            Showing Total <b>{{ listSkuResult.length }} SKU ID</b>
          </p>
          <div class="search-sku-wrapper">
            <svg
              width="20"
              height="20"
              viewBox="0 0 20 20"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <g id="vuesax/outline/search-normal">
                <g id="search-normal">
                  <path
                    id="Vector"
                    d="M9.58268 18.1253C4.87435 18.1253 1.04102 14.292 1.04102 9.58366C1.04102 4.87533 4.87435 1.04199 9.58268 1.04199C14.291 1.04199 18.1243 4.87533 18.1243 9.58366C18.1243 14.292 14.291 18.1253 9.58268 18.1253ZM9.58268 2.29199C5.55768 2.29199 2.29102 5.56699 2.29102 9.58366C2.29102 13.6003 5.55768 16.8753 9.58268 16.8753C13.6077 16.8753 16.8743 13.6003 16.8743 9.58366C16.8743 5.56699 13.6077 2.29199 9.58268 2.29199Z"
                    fill="#B6B6B6"
                  />
                  <path
                    id="Vector_2"
                    d="M18.3326 18.9585C18.1742 18.9585 18.0159 18.9002 17.8909 18.7752L16.2242 17.1085C15.9826 16.8669 15.9826 16.4669 16.2242 16.2252C16.4659 15.9835 16.8659 15.9835 17.1076 16.2252L18.7742 17.8919C19.0159 18.1335 19.0159 18.5335 18.7742 18.7752C18.6492 18.9002 18.4909 18.9585 18.3326 18.9585Z"
                    fill="#B6B6B6"
                  />
                </g>
              </g>
            </svg>
            <input
              placeholder="Search Product Name/ Item Number/HS Code"
              v-model="searchSku"
            />
          </div>
        </div>

        <!-- list SKU -->
        <template v-if="listSkuResult.length > 0">
          <div
            v-for="(item, index) in listSkuResult"
            :key="item.id"
            class="d-flex align-items-start"
          >
            <div class="text-base font-semibold text-1d3354 mr-3">
              {{ index + 1 }}.
            </div>
            <div class="bg-card-list mb-3">
              <div class="row">
                <div class="col-10 row">
                  <!-- col 1 -->
                  <div
                    class="col-md-7 col text-1d3354 border-right border-e1e1e1"
                  >
                    <div class="d-flex align-items-start">
                      <div style="width: 109px; height: 82px;">
                        <img
                          :src="item.img"
                          :alt="`sku-image-${item.id}`"
                          width="109"
                          height="82"
                          style="border-radius: 8px;"
                        />
                      </div>
                      <div class="ml-4 w-100">
                        <div class="row p-0 align-items-center mb-2">
                          <p class="col text-sm text-6e6e6e">
                            SKU ID
                          </p>
                          <p class="col text-sm">
                            :
                            <span class="font-semibold">{{
                              item.skuId || '-'
                            }}</span>
                          </p>
                        </div>
                        <div class="row p-0 align-items-center mb-2">
                          <p class="col text-sm text-6e6e6e">
                            Product Name
                          </p>
                          <p class="col text-sm">
                            :
                            <span class="font-semibold">{{
                              item.productInformation || '-'
                            }}</span>
                          </p>
                        </div>
                        <div class="row p-0 align-items-center mb-2">
                          <p class="col text-sm text-6e6e6e">
                            Country of Origin
                          </p>
                          <p class="col text-sm">
                            :
                            <span class="font-semibold">{{
                              item.countryOrigin || '-'
                            }}</span>
                          </p>
                        </div>
                        <div class="row p-0 align-items-center mb-2">
                          <p class="col text-sm text-6e6e6e">
                            Item Number
                          </p>
                          <p class="col text-sm">
                            :
                            <span class="font-semibold">{{
                              item.itemNumber || '-'
                            }}</span>
                          </p>
                        </div>
                        <div class="row p-0 align-items-center mb-2">
                          <p class="col text-sm text-6e6e6e">
                            HS Code
                          </p>
                          <p class="col text-sm">
                            :
                            <span class="font-semibold">{{
                              item.hsCode || '-'
                            }}</span>
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <!-- col 2 -->
                  <div class="col-md-5 col text-1d3354">
                    <div class="row p-0 align-items-center mb-2">
                      <p class="col text-sm text-6e6e6e">
                        CIF
                      </p>
                      <p class="col text-sm">
                        :
                        <span class="font-semibold">{{ item.cif || '-' }}</span>
                      </p>
                    </div>
                    <div class="row p-0 align-items-center mb-2">
                      <p class="col text-sm text-6e6e6e">
                        Packaging Type
                      </p>
                      <p class="col text-sm">
                        :
                        <span class="font-semibold">{{
                          item.packagingType || '-'
                        }}</span>
                      </p>
                    </div>
                    <div class="row p-0 align-items-center mb-2">
                      <p class="col text-sm text-6e6e6e">Gross Weight</p>
                      <p class="col text-sm">
                        :
                        <span class="font-semibold">{{
                          item.weight
                            ? parseFloat(item.weight).toLocaleString() + ' kg'
                            : '-'
                        }}</span>
                      </p>
                    </div>
                    <div class="row p-0 align-items-center mb-2">
                      <p class="col text-sm text-6e6e6e">Nett Weight</p>
                      <p class="col text-sm">
                        :
                        <span class="font-semibold">{{
                          item.nettWeight
                            ? parseFloat(item.nettWeight).toLocaleString() +
                              ' kg'
                            : '-'
                        }}</span>
                      </p>
                    </div>
                    <div class="row p-0 align-items-center mb-2">
                      <p class="col text-sm text-6e6e6e">
                        Quantity
                      </p>
                      <p class="col text-sm">
                        :
                        <span class="font-semibold">{{
                          item.quantity
                            ? parseFloat(item.quantity).toLocaleString()
                            : '-'
                        }}</span>
                      </p>
                    </div>
                  </div>
                </div>
                <div class="col-2">
                  <button
                    class="button__whiteblueborder mb-2"
                    style="min-width: 118px;
                      min-height: 29px;
                      padding: 4px 6px;
                      display: flex;
                      align-items: center;
                      justify-content: center;
                      border-radius: 4px !important;
                      font-size: 12px !important;"
                    @click="editModalSKU(item)"
                  >
                    Edit SKU
                  </button>
                  <button
                    class="button__whiteredborder"
                    style="min-width: 118px;
                min-height: 29px;
                      padding: 4px 6px;
                      display: flex;
                      align-items: center;
                      justify-content: center;
                      border-radius: 4px !important;
                      font-size: 12px !important;"
                    @click="deleteList(index, item)"
                  >
                    Delete
                  </button>
                </div>
              </div>
              <div
                class="w-100 d-flex pr-0 align-items-start mb-2 ml-4"
                style="padding-left: 109px"
              >
                <p class="text-sm text-6e6e6e" style="width: 172.85px">Notes</p>
                <p
                  class="d-flex align-items-start text-sm text-1d3354"
                  style="width: calc(100% - 172.85px)"
                >
                  <span class="mr-1">:</span>
                  <span class="font-semibold pr-2" v-html="item.notes || '-'" />
                </p>
              </div>
              <div class="d-flex align-items-start mt-2 border-top mt-3 pt-3">
                <p class="pdetail__paragraph1 d-flex" style="min-width: 156px;">
                  <span>Uploaded Document</span><span class="px-2">:</span>
                </p>
                <div class="d-flex align-items-center" style="flex-wrap: wrap;">
                  <div
                    class="pdetail__paragraph2"
                    v-for="(file, i) in item.fileName"
                    :key="i"
                  >
                    <p
                      class="d-flex"
                      style="
                                text-decoration: underline !important;
                                cursor: pointer;
                              "
                    >
                      <span>{{ file ? file.name : '' }}</span>
                      <span class="px-2">{{
                        i != item.fileName.length - 1 ? ',' : ''
                      }}</span>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </template>
        <div
          v-else
          class="pdetail__border d-flex justify-content-center align-items-center p-4 mb-5"
          style="height: 130px;"
        >
          <div class="pdetail__paragraph1 text-center">
            <svg
              width="32"
              height="32"
              viewBox="0 0 32 32"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <g id="vuesax/bold/document-text">
                <g id="document-text">
                  <path
                    id="Vector"
                    d="M21.3333 2.66699H10.6667C6 2.66699 4 5.33366 4 9.33366V22.667C4 26.667 6 29.3337 10.6667 29.3337H21.3333C26 29.3337 28 26.667 28 22.667V9.33366C28 5.33366 26 2.66699 21.3333 2.66699ZM10.6667 16.3337H16C16.5467 16.3337 17 16.787 17 17.3337C17 17.8803 16.5467 18.3337 16 18.3337H10.6667C10.12 18.3337 9.66667 17.8803 9.66667 17.3337C9.66667 16.787 10.12 16.3337 10.6667 16.3337ZM21.3333 23.667H10.6667C10.12 23.667 9.66667 23.2137 9.66667 22.667C9.66667 22.1203 10.12 21.667 10.6667 21.667H21.3333C21.88 21.667 22.3333 22.1203 22.3333 22.667C22.3333 23.2137 21.88 23.667 21.3333 23.667ZM24.6667 12.3337H22C19.9733 12.3337 18.3333 10.6937 18.3333 8.66699V6.00033C18.3333 5.45366 18.7867 5.00033 19.3333 5.00033C19.88 5.00033 20.3333 5.45366 20.3333 6.00033V8.66699C20.3333 9.58699 21.08 10.3337 22 10.3337H24.6667C25.2133 10.3337 25.6667 10.787 25.6667 11.3337C25.6667 11.8803 25.2133 12.3337 24.6667 12.3337Z"
                    fill="#B6B6B6"
                  />
                </g>
              </g>
            </svg>
            <p>Not Found</p>
          </div>
        </div>
        <!-- end list SKU -->
      </div>
    </div>
    <ModalSKU
      :viewModal="addModal"
      :editData="editData"
      @callBackSubmit="callBackData"
      @deleteData="editData = {}"
    />
    <MultipleSKUModal
      :viewModal.sync="multipleSKUModal"
      @handle-result="handleResultMultipleSkuUpload($event)"
    />
    <SupportingDocumentModal
      :viewModal.sync="supportingDocumentModal"
      @add-supporting-document="handleAddSupportingDocument($event)"
    />
    <div class="modals">
      <b-modal
        ref="confirmInbound"
        id="modalConfirmInbound"
        centered
        hide-footer
        title="Confirmation"
      >
        <div class="__body text-center">
          <p class="mb-2">
            Are you sure that you want to {{ type }} this Inbound?
          </p>
          <div class="d-flex justify-content-center mt-4">
            <button
              class="button__redcorporite mr-3"
              @click="$refs.confirmInbound.hide()"
            >
              No
            </button>
            <button class="button__bluecorporite" @click="draftSubmit()">
              <div
                class="text-center"
                v-if="isLoadingPostDraft || isLoadingPostSubmit"
              >
                <b-spinner label="Loading..."></b-spinner>
              </div>
              <span v-else>Yes</span>
            </button>
          </div>
        </div>
      </b-modal>
      <b-modal
        id="modalPublishSuccess"
        ref="modalSuccessIQ"
        centered
        hide-footer
        title=""
      >
        <div>
          <div class="d-flex justify-content-center mb-2">
            <img
              style="width: 68px; height: 68px"
              src="@/assets/image/image/complete.png"
              alt=""
            />
          </div>
          <p class="text-center">
            {{
              type === 'draft'
                ? 'Draft Inbound has been added'
                : 'New Inbound has been submitted'
            }}
          </p>
        </div>
        <div class="row mt-4">
          <div class="col-md text-center">
            <b-button
              @click="$refs.modalSuccessIQ.hide()"
              class="button__bluecorporite"
              >Ok
            </b-button>
          </div>
        </div>
      </b-modal>
      <ModalInfo
        :openModal.sync="dataModalInfo.show"
        :dataModal="dataModalInfo"
      />
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import moment from 'moment'
import ModalSKU from '@/components/global/modals/modalAddSKU.vue'
import MultipleSKUModal from '@/components/global/modals/MultipleSKUModal.vue'
import SupportingDocumentModal from '@/components/global/modals/SupportingDocumentModal.vue'
import ModalInfo from '../global/modals/ModalInfo.vue'
export default {
  name: 'formwarehouse',
  components: {
    ModalSKU,
    MultipleSKUModal,
    ModalInfo,
    SupportingDocumentModal
  },
  data() {
    return {
      form: {
        warehouse: '',
        dateInbound: '',
        referenceNumber: '',
        nomorPengajuan: '',
        fileSupportingDocument: [],
        multipleSkuStatus: 0
      },
      type: '',
      searchSku: '',
      editData: {},
      addModal: false,
      multipleSKUModal: false,
      supportingDocumentModal: false,
      listData: [],
      skuDeletedId: [],
      dataModalInfo: {
        show: false,
        text: '',
        img: require('@/assets/image/icon/checklist-success.svg'),
        typeModal: 'INFO', // CONFIRM (button yes & no), INFO (button ok)
        buttons: null
      }
    }
  },
  computed: {
    ...mapGetters({
      warehouseList: 'warehouse/warehouseList',
      isLoadingWarehouseList: 'warehouse/isLoadingWarehouseList',
      errorWarehouseList: 'warehouse/errorWarehouseList',

      postDraft: 'warehouse/postDraft',
      isLoadingPostDraft: 'warehouse/isLoadingPostDraft',
      errorPostDraft: 'warehouse/errorPostDraft',

      postSubmit: 'warehouse/postSubmit',
      isLoadingPostSubmit: 'warehouse/isLoadingPostSubmit',
      errorPostSubmit: 'warehouse/errorPostSubmit',

      inboundDetail: 'warehouse/inboundDetail',
      isLoadingInboundDetail: 'warehouse/isLoadingInboundDetail',
      errorInboundDetail: 'warehouse/errorInboundDetail',

      multipleSkuUpload: 'warehouse/multipleSkuUpload'
    }),
    listSkuResult() {
      try {
        if (this.searchSku) {
          const result = this.listData.filter(
            el =>
              String(el.productInformation)
                .toLowerCase()
                .includes(this.searchSku.toLowerCase()) ||
              String(el.itemNumber)
                .toLowerCase()
                .includes(this.searchSku.toLowerCase()) ||
              String(el.hsCode)
                .toLowerCase()
                .includes(this.searchSku.toLowerCase())
          )
          return result
        } else {
          return this.listData
        }
      } catch (error) {
        return this.listData
      }
    }
  },
  watch: {
    inboundDetail(data) {
      if (data) {
        this.listData = []
        if (
          this.$route.params.type === 'draft' &&
          this.warehouseList &&
          this.warehouseList.length > 0
        ) {
          const selectedWarehouse = this.warehouseList.find(
            el => el.id == data.warehouseId
          )
          if (selectedWarehouse) {
            this.form.warehouse = selectedWarehouse
          } else {
            this.form.warehouse = { id: data.id, name: data.warehouseName }
          }
        }
        this.form.dateInbound = data.inboundDate
        this.form.nomorPengajuan = data.nomorPengajuan || ''
        this.form.referenceNumber = data.referenceNumber || ''
        this.form.multipleSkuStatus = data.multipleSkuStatus
        this.form.fileSupportingDocument = data.supportingDoc

        data.sku.forEach(item => {
          this.listData.push({
            index: this.listData.length + 1,
            id: item.id,
            img:
              item.pictureUrl || require('@/assets/image/empty-sku-image.png'),
            skuId: item.skuId || '-',
            companyName: data.companyName,
            productInformation: item.productInformation,
            quantity: Number(item.quantity),
            nettWeight: Number(item.nettWeight),
            weight: Number(item.weight),
            countryOrigin: item.countryOrigin,
            cif: item.cif,
            itemNumber: item.itemNumber || '',
            hsCode: item.hsCode || '',
            packagingType: item.packagingType || '',
            notes: item.notes,
            fileName: item.files,
            dataFoto: item.filePicture[0] || null,
            fileDelete: []
          })
        })
      }
    }
  },
  async mounted() {
    await this.init()
  },
  methods: {
    async init() {
      await this.$store.dispatch('warehouse/FETCH_WAREHOUSE_LIST')
      if (this.$route.params.type === 'draft') {
        const filter = ''
        await this.$store.dispatch('warehouse/FETCH_SKU_DETAIL', {
          id: this.$route.query.id,
          filter
        })
      }
    },
    callBackData(data) {
      if (data.titleModal === 'Add') {
        this.listData.push({
          index: this.listData.length + 1,
          img:
            data.pictureName || require('@/assets/image/empty-sku-image.png'),
          id: `SKU00${this.listData.length + 1}`,
          skuId: data.skuId || '-',
          companyName: data.companyName,
          productInformation: data.productInformation,
          quantity: data.quantity,
          nettWeight: data.nettWeight,
          weight: data.weight,
          countryOrigin: data.countryOrigin,
          cif: data.cif,
          itemNumber: data.itemNumber,
          hsCode: data.hsCode,
          packagingType: data.packagingType,
          notes: data.notes,
          fileName: data.fileDocumentUpload,
          dataFoto: data.picture,
          fileDelete: data.fileDelete
        })
      } else {
        this.listData[data.index - 1].fileName = []
        this.listData[data.index - 1] = {
          index: data.index,
          id: data.id,
          img:
            data.pictureName || require('@/assets/image/empty-sku-image.png'),
          skuId: data.skuId || '-',
          companyName: data.companyName,
          productInformation: data.productInformation,
          quantity: data.quantity,
          nettWeight: data.nettWeight,
          weight: data.weight,
          countryOrigin: data.countryOrigin,
          cif: data.cif,
          itemNumber: data.itemNumber,
          hsCode: data.hsCode,
          packagingType: data.packagingType,
          notes: data.notes,
          fileName: data.fileDocumentUpload,
          dataFoto: data.picture,
          fileDelete: data.fileDelete
        }
      }
    },
    confirm(type) {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.type = type
          this.$refs.confirmInbound.show()
        }
      })
    },
    draftSubmit() {
      const skuList = []
      let formData = new FormData()
      this.listData.forEach(item => {
        skuList.push({
          index: item.index,
          id: item.id,
          productInformation: item.productInformation,
          quantity: item.quantity,
          nettWeight: item.nettWeight,
          weight: item.weight,
          countryOrigin: item.countryOrigin,
          cif: item.cif,
          itemNumber: item.itemNumber,
          hsCode: item.hsCode,
          packagingType: item.packagingType,
          notes: item.notes,
          fileDeleteId: item.fileDelete
        })
        if (item.dataFoto && !item.dataFoto.id) {
          formData.append(`filePictureSku_${item.id}`, item.dataFoto)
        }
        item.fileName.filter(file => {
          if (!file.id) {
            formData.append(`fileDocumentSku_${item.id}`, file)
          }
        })
      })
      if (
        this.form.fileSupportingDocument &&
        this.form.fileSupportingDocument.length > 0
      ) {
        this.form.fileSupportingDocument.forEach(item => {
          formData.append('fileSupportingDocument', item)
        })
      } else {
        formData.append('fileSupportingDocument', null)
      }
      formData.append('multipleSkuStatus', this.form.multipleSkuStatus)
      formData.append('skuList', JSON.stringify(skuList))
      formData.append('warehouseId', this.form.warehouse.id)
      formData.append('inboundDate', this.form.dateInbound)
      formData.append('referenceNumber', this.form.referenceNumber)
      formData.append('nomorPengajuan', this.form.nomorPengajuan)
      formData.append(
        'inboundId',
        this.$route.params.type === 'draft' ? this.$route.query.id : ''
      )
      if (this.skuDeletedId.length > 0) {
        this.skuDeletedId.forEach(item => {
          formData.append('skuDeletedId[]', item)
        })
      }
      if (this.type === 'draft') {
        this.$store
          .dispatch('warehouse/POST_WAREHOUSE_DRAFT', formData)
          .then(() => {
            if (!this.errorPostDraft) {
              this.$router.push({
                name: 'warehouseList',
                params: {
                  type: 'draft'
                }
              })
            } else {
              this.dataModalInfo.text = 'Internal Server Error!'
              this.dataModalInfo.img = require('@/assets/image/icon/failed.svg')
              this.dataModalInfo.show = true
              this.$refs.confirmInbound.hide()
            }
          })
      } else {
        this.$store
          .dispatch('warehouse/POST_WAREHOUSE_SUBMIT', formData)
          .then(() => {
            if (!this.errorPostSubmit) {
              this.$router.push({
                name: 'warehouseList',
                params: {
                  type: 'waiting-inbound'
                }
              })
            } else {
              this.dataModalInfo.text = 'Internal Server Error!'
              this.dataModalInfo.img = require('@/assets/image/icon/failed.svg')
              this.dataModalInfo.show = true
              this.$refs.confirmInbound.hide()
            }
          })
      }
    },
    addModalSKU() {
      this.addModal = true
      setTimeout(() => {
        this.addModal = false
      }, 2000)
    },
    openMultipleSKUModal() {
      this.multipleSKUModal = true
    },
    editModalSKU(data) {
      this.addModal = true
      this.editData = data
      setTimeout(() => {
        this.addModal = false
      }, 2000)
    },
    deleteList(index, item) {
      this.listData.splice(index, 1)
      if (
        item.id &&
        !String(item.id)
          .toLowerCase()
          .includes('sku')
      ) {
        this.skuDeletedId.push(item.id)
      }
      // jika list nya sudah kosong, maka button Add Multiple SKU Status di enable lagi
      if (this.listData.length == 0) {
        this.form.multipleSkuStatus = 0
      }
    },
    getDate(date) {
      return moment(date).format('YYYY-MM-DD')
    },
    handleResultMultipleSkuUpload(data) {
      // this.dataModalInfo.show = false;
      if (data.status && this.multipleSkuUpload) {
        this.multipleSkuUpload.data.forEach(item => {
          this.listData.push({
            index: this.listData.length + 1,
            id: item.id,
            img: require('@/assets/image/empty-sku-image.png'),
            skuId: '-',
            productInformation: item.productInformation,
            quantity: Number(item.quantity),
            nettWeight: Number(item.nettWeight),
            weight: Number(item.weight),
            countryOrigin: item.countryOrigin,
            cif: item.cif,
            itemNumber: item.itemNumber || '',
            hsCode: item.hsCode || '',
            packagingType: item.packagingType || '',
            notes: item.notes,
            fileName: [],
            dataFoto: null,
            fileDelete: item.fileDeleteId
          })
        })
        this.form.multipleSkuStatus = this.multipleSkuUpload.multipleSkuStatus
        this.form.fileSupportingDocument = data.fileSupportingDocument
      } else {
        this.dataModalInfo.text = data.data
        this.dataModalInfo.img = require('@/assets/image/icon/failed.svg')
        this.dataModalInfo.show = true
      }
    },
    handleAddSupportingDocument(fileDocumentUpload) {
      this.form.fileSupportingDocument = [
        ...this.form.fileSupportingDocument,
        ...fileDocumentUpload
      ]
    }
  }
}
</script>

<style lang="scss">
.bg-card-list {
  border-radius: 8px;
  width: 100%;
  border: 1px solid var(--neutral-100, #f5f6f7);
  background: var(--base-white, #fff);
  box-shadow: 0px 1px 2px 0px rgba(16, 24, 40, 0.06),
    0px 1px 3px 0px rgba(16, 24, 40, 0.1);
}
.pdetail {
  &__header {
    font-size: 16px;
    font-weight: 700;
    color: #1d3354;
    @media only screen and (max-width: 1536px) {
      margin: 1.5rem 0rem 0.5rem 0rem !important;
    }
  }
  &__paragraph1 {
    font-size: 14px;
    font-weight: 400;
    color: #6e6e6e;
  }
  &__paragraph2 {
    font-size: 14px;
    font-weight: 600;
    color: #1d3354;
    word-break: break-all;
  }
  &__border {
    border: 1px solid #dadee2;
    border-radius: 8px;
    @media only screen and (min-width: 1536px) {
      padding: 1.5rem;
    }
    padding: 1rem;
    column-gap: 1rem;
  }
  &__buttonwhite {
    width: 185px;
    height: 36px;
    color: #1d3354;
    border: 1px solid #1d3354;
    box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.12);
    border-radius: 4px;
    background: #ffffff;
    font-weight: 600;
    font-size: 14px;
    line-height: 24px;
    letter-spacing: -0.011em;
  }
  &__buttonred {
    width: 100px;
    height: 36px;
    color: #c4232a;
    border: 1px solid #c4232a;
    box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.12);
    border-radius: 4px;
    background: #ffffff;
    font-weight: 600;
    font-size: 14px;
    line-height: 24px;
    letter-spacing: -0.011em;
  }
}
#checkboxAir {
  font-size: 14px !important;
  color: #686868 !important;
}
.customplaceholder {
  ::placeholder {
    color: #9ea1a4 !important;
  }

  @media only screen and (min-width: 1536px) {
    width: 100%;
  }

  width: 73%;
}
.search-sku-wrapper {
  display: flex;
  align-items: center;
  border-radius: 8px;
  border: 1px solid #d2d2d2;
  padding: 6px 8px;
  height: 40px;
  input {
    margin-left: 8px;
    font-size: 14px;
    line-height: 24px;
    min-width: 335px;
    border: none;
    color: #7a7c7e;
    ::placeholder {
      color: #7a7c7e;
    }
    :focus {
      outline: none;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/warehouse/FormWarehouse.vue